/* ControlDevicesPage — §64-65 */
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { controlApi, useAuth } from "../lib/controlApi";
import { ChevronLeft, Loader2, Smartphone, Laptop, Tablet, Monitor } from "lucide-react";

function iconFor(platform) {
  if (["ios", "android", "mobile"].includes(platform)) return Smartphone;
  if (platform === "macos" || platform === "windows") return Laptop;
  if (platform === "linux") return Monitor;
  return Tablet;
}

export default function ControlDevicesPage() {
  const { logout } = useAuth();
  const [items, setItems] = useState([]);
  const [currentSid, setCurrentSid] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await controlApi.sessions();
      setItems(r.sessions || []); setCurrentSid(r.current_session_id);
    } catch { /* noop */ } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const revoke = async (sid) => {
    try { await controlApi.revokeSession(sid); toast.success("Sesión cerrada."); load(); }
    catch { toast.error("Error"); }
  };

  const closeAll = async () => {
    if (!confirm("Esto cerrará TODAS las sesiones (incluyendo este dispositivo). ¿Continuar?")) return;
    try {
      await controlApi.logoutAll();
      logout();
    } catch { toast.error("Error"); }
  };

  return (
    <div className="p-4 space-y-3" data-testid="spc-devices">
      <div className="flex items-center gap-2">
        <Link to="/control/more" className="text-textgray"><ChevronLeft className="w-4 h-4" /></Link>
        <div>
          <div className="text-[10px] uppercase tracking-[0.35em] text-textgray">Dispositivos</div>
          <div className="font-serif text-xl font-bold text-blueblack">Sesiones activas</div>
        </div>
      </div>
      {loading ? <div className="text-center p-6"><Loader2 className="w-4 h-4 animate-spin mx-auto text-textgray" /></div> : (
        <ul className="border border-softblue bg-white divide-y divide-softblue">
          {items.map((d) => {
            const Icon = iconFor(d.platform);
            return (
              <li key={d.id} className="p-3 flex items-start gap-3">
                <Icon className="w-5 h-5 text-blueblack mt-0.5" />
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-bold text-blueblack">
                    {d.device_name || d.platform || "Dispositivo"}
                    {d.is_current && <span className="ml-2 text-[10px] uppercase tracking-widest text-emerald-700">· Este</span>}
                  </div>
                  <div className="text-[11px] text-textgray">
                    {d.platform} · {d.ip || "IP oculta"}
                  </div>
                  <div className="text-[10px] text-textgray mt-0.5">
                    Activo: {d.last_active_at ? new Date(d.last_active_at).toLocaleString("es-AR", { timeZone: "America/Argentina/Ushuaia" }) : "—"}
                  </div>
                </div>
                {!d.is_current && (
                  <button onClick={() => revoke(d.id)} data-testid={`spc-revoke-${d.id}`}
                    className="h-8 px-3 text-[10px] uppercase tracking-widest font-bold border border-softblue bg-white text-blueblack">
                    Cerrar
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      )}
      <button onClick={closeAll} data-testid="spc-close-all"
        className="w-full h-11 border border-red-300 bg-red-50 text-red-700 text-[11px] uppercase tracking-widest font-bold">
        Cerrar todas las sesiones
      </button>
    </div>
  );
}
